import { ApplicationState } from 'types';

import { SxProps, Theme, useTheme } from '@mui/material';
import { Box } from '@mui/system';

import { getStateBadgeLabel } from './helpers';

const STATE_CLASS: Record<ApplicationState, string> = {
  draft: "upcoming",
  deleted_by_client: "cancelled",
  in_review: "inReview",
  ready_for_issuance: "readyForIssuance",
  client_action_needed: "clientActionNeeded",
  certificate_draft_issued: "clientActionNeeded",
  pending_payment: "pendingPayment",
  completed: "completed",
  swo: "swo",
  denied: "cancelled",
};

export interface ApplicationStateBadgeProps {
  appState: ApplicationState;
  type?: "client" | "admin";
}

const getStyles = (theme: Theme): { [key: string]: SxProps } => {
  return {
    badge: {
      display: "flex",
      textTransform: "uppercase",
      borderRadius: "5px",
      height: "35px",
      fontSize: "14px",
      padding: "0 10px",
      alignItems: "center",
      "&.cancelled, &.swo": {
        border: `1px solid #aa002c`,
        background: "#ffe9ee",
        color: "#535863",
      },
      "&.completed": {
        border: "1px solid #166d12",
        background: "#e9f3e8",
        color: "#535863",
      },

      "&.upcoming": {
        border: `1px solid rgba(103, 112, 126, 0.5)`,
        color: theme.palette.text.primary,
        background: "rgba(225, 229, 233, 0.5)",
      },
      "&.pendingPayment": {
        border: `1px solid #B05E11`,
        color: theme.palette.text.primary,
        background: "#FFF3E6",
      },
      "&.clientActionNeeded": {
        border: `1px solid #B05E11`,
        color: theme.palette.text.primary,
        background: "#FFF3E6",
      },
      "&.draftInProgress": {
        border: `1px solid #67707E`,
        color: theme.palette.text.primary,
        background: "#0062A0",
      },
      "&.inReview, &.readyForIssuance": {
        border: `1px solid #67707E`,
        color: theme.palette.common.white,
        background: "#0062A0",
      },
    },
  };
};

export default function ApplicationStateBadge(
  props: ApplicationStateBadgeProps
) {
  const { appState, type = "client" } = props;

  const theme = useTheme();
  const styles = getStyles(theme);
  return (
    <Box sx={styles.badge} className={STATE_CLASS[appState]}>
      {getStateBadgeLabel(type, appState)}
    </Box>
  );
}
